import $ from 'jquery';
import * as jcf from 'jcf/dist/js/jcf';

export function checkIncompatibilities(incompatibilities, className, $this) {

    var tabIncompatibilities, i, $incompatibleAccessory, $incompatibleServiceName;

    if (incompatibilities !== '' && typeof incompatibilities !== 'undefined') {

        if (incompatibilities.indexOf(',') > 0) {
            tabIncompatibilities = incompatibilities.split(',');
            for (i = 0; i < tabIncompatibilities.length; i++) {

                $incompatibleAccessory = $('.' + className + '[data-id=' + tabIncompatibilities[i] + ']');
                $incompatibleServiceName = $this.attr('data-service-name');

                if ($this.is(':checked')) {
                    $incompatibleAccessory.prop('checked', false);
                    jcf.refresh($incompatibleAccessory);

                    //  Masquer le commentaire indiquant que l'accessoire est inclus
                    modifyAccessoryDetailIfContain(tabIncompatibilities[i], 'Inclus', 'incompatible', $incompatibleServiceName);
                    // On va recocher les accessoires obligatoires
                    checkIncompatibilities($incompatibleAccessory.attr('data-incompatibilities'), className, $incompatibleAccessory);
                }
                else if ($incompatibleAccessory.is(':disabled')) {
                    $incompatibleAccessory.prop('checked', true);

                    //  Afficher le commentaire indiquant que l'accessoire est inclus
                    modifyAccessoryDetailIfContain(tabIncompatibilities[i], 'Incompatible', 'compatible', $incompatibleServiceName);

                    jcf.refresh($incompatibleAccessory);
                }
            }
        }
        else {

            $incompatibleAccessory = $('.' + className + '[data-id=' + incompatibilities + ']');

            if ($this.is(':checked')) {
                $incompatibleAccessory.prop('checked', false);
                jcf.refresh($incompatibleAccessory);

                //  Masquer le commentaire indiquant que l'accessoire est inclus
                modifyAccessoryDetailIfContain(incompatibilities, 'Inclus', 'incompatible');

                // On va recocher les accessoires obligatoires
                checkIncompatibilities($incompatibleAccessory.attr('data-incompatibilities'), className, $incompatibleAccessory);
            }
            else if ($incompatibleAccessory.is(':disabled')) {
                $incompatibleAccessory.prop('checked', true);

                //  Afficher le commentaire indiquant que l'accessoire est inclus
                modifyAccessoryDetailIfContain(incompatibilities, 'Incompatible', 'compatible');

                jcf.refresh($incompatibleAccessory);
            }
        }
    }

}

function modifyAccessoryDetailIfContain(accessoryId, text, action, service = null) {

    var $detailSpan = $('.details span[data-accessoryId="' + accessoryId + '"]:contains("' + text + '")');
    let complementaryText = '';

    if (service){
        complementaryText = ' avec le service ' + service;
    }

    if ($detailSpan) {

        if (action == 'incompatible') {
            $detailSpan.html('Incompatible' + complementaryText + '.');
        } else {
            $detailSpan.html('Inclus.');
        }
    }

}
